import { graphql } from '../../graphql';

export const createPaymentMutation = graphql(`
  mutation CreatePayment(
    $amount: Float
    $paidServiceId: ID!
    $paidServiceOptionId: ID!
    $paymentMethodId: ID!
    $targetId: [ID!]!
    $platform: PaymentCreatePlatformEnum
    $cardToken: String
    $yigimTemplateGroup: PaymentCreateYigimTemplateGroupEnum
  ) {
    createPayment(
      input: {
        amount: $amount
        paidServiceId: $paidServiceId
        paidServiceOptionId: $paidServiceOptionId
        paymentMethodId: $paymentMethodId
        targetId: $targetId
        platform: $platform
        cardToken: $cardToken
        yigimTemplateGroup: $yigimTemplateGroup
      }
    ) {
      status
      redirectUrl
      paymentId
      errors {
        code
        message
        path
      }
    }
  }
`);
